import { useEffect, useState } from "react";
import { apiRequest } from "../../lib/api";
import { useAsync } from "../../hooks/useAsync";
import { useToast } from "../../context/ToastContext";

type Preferences = { allNew: boolean; assigned: boolean; replies: boolean; teams: boolean; pushEnabled: boolean };
const labels: Record<keyof Preferences, string> = {
  allNew: "New tickets across the support queue",
  assigned: "Tickets assigned to me",
  replies: "Customer replies on tickets assigned to me or followed by me",
  teams: "Include tickets belonging to my teams",
  pushEnabled: "Allow push notifications on my subscribed devices",
};
export function NotificationPreferences() {
  const result = useAsync(() => apiRequest<Preferences>("/push/preferences"), []);
  const [form, setForm] = useState<Preferences | null>(null);
  const [busy, setBusy] = useState(false);
  const { showToast } = useToast();
  useEffect(() => { if (result.data) setForm(result.data); }, [result.data]);
  async function save() {
    setBusy(true);
    try {
      await apiRequest("/push/preferences", { method: "PUT", body: form });
      showToast("Notification preferences saved.", "success");
    } catch (error) { showToast(error instanceof Error ? error.message : "Could not save preferences.", "error"); }
    finally { setBusy(false); }
  }
  return <section className="settings-section card">
    <header><div><h2>Ticket notifications</h2><p>These preferences follow your staff account. Enable push on each device separately below. Spam and security quarantine do not generate these alerts.</p></div></header>
    <div className="inline-admin-form">
      <p className="field-hint">SLA reminder emails are controlled by the admin-wide automation settings, not these personal preferences.</p>
      {result.error ? <p role="alert">{result.error} <button type="button" onClick={() => void result.refresh()}>Retry</button></p>
        : !form ? <p role="status">Loading preferences...</p> : <>
          <div className="notification-preferences">{(Object.keys(labels) as Array<keyof Preferences>).map((key) =>
            <label key={key}><input type="checkbox" checked={form[key]} onChange={(event) => setForm({ ...form, [key]: event.target.checked })} /> {labels[key]}</label>)}</div>
          <div className="form-actions"><button className="button button--primary" type="button" disabled={busy} onClick={() => void save()}>{busy ? "Saving..." : "Save notification preferences"}</button></div>
        </>}
    </div>
  </section>;
}
